// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as CrmNetwork from "../../../../../../library/network/CrmNetwork.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as UserRoleRepoConfig from "./UserRoleRepoConfig.bs.js";

function fetchUserDetails(country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/pricingsystems/ondemand/core_pricing/campaigns/admin_details";
  return CrmNetwork.get(requestUrl, undefined, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(UserRoleRepoConfig.UserRoleResponseConverter.execute, result);
                        });
            });
}

var UserRoleRepo = {
  fetchUserDetails: fetchUserDetails
};

export {
  UserRoleRepo ,
  
}
/* Config Not a pure module */
